import { createSelector } from '@ngrx/store';
import { getWizzardIngredientsQuantityForGroup } from '../getWizzardIngredientsQuantityForGroup';

export const isWizzardLimitReachedForIngredientsGroup = (productIngredient: APICommon.ProductIngredientExtended) =>
    createSelector(getWizzardIngredientsQuantityForGroup(productIngredient.IngredientDisplayGroupId), (currentGroupQuantity) => {
        if (!Number.isInteger(currentGroupQuantity)) return null;

        return (
            (productIngredient.IngredientDisplayGroupMaxCount === null && currentGroupQuantity === 1) ||
            (productIngredient.IngredientDisplayGroupMaxCount !== null && currentGroupQuantity >= productIngredient.IngredientDisplayGroupMaxCount)
        );
    });
